// @flow

import * as React from 'react';

import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';

import { datetime } from 'app/lib/format';
import { distance as relativeTimeDistance } from 'app/lib/date-fns';

export default ({ column, item }) => {
  const dateStr = item[column.id];
  const dateObject = dateStr && new Date(dateStr);

  return (
    <TableCell
      padding={column.disablePadding ? 'none' : column.padding || 'normal'}
      align={column.align}
    >
      {dateObject ? (
        <Tooltip title={datetime.format(dateObject)}>
          <span>{relativeTimeDistance(dateObject, Date.now())}</span>
        </Tooltip>
      ) : null}
    </TableCell>
  );
};